module.exports = __webpack_public_path__ + "img/shape-1.08ed8ed1.png";